import React from 'react';

import SpinnerDiv from "ui/SpinnerDiv";
import TabbedBasePage from "../Base/ReactTabbedBasePage";
import ChildProgressReviewAttendance2 from "../Attendance/ChildProgressReviewAttendance2";
import ChildProgressReviewAttendance from "./ReactChildProgressReviewAttendance";
import ChildProgressReviewAchievement from "./ReactChildProgressReviewAchievement";
import ChildProgressReviewAchievementLegacy from "./ReactChildProgressReviewAchievementLegacy";
import ChildProgressReviewFeedback from "./ReactChildProgressReviewFeedback";
import ChildPupilPremiumPlus from "../Attendance/ReactChildPupilPremiumPlus";
import ChildProgressReviewSelectChildForm from "./ReactChildProgressReviewSelectChildForm";
import ChildProgressReviewConfirmDateForm from "./ReactChildProgressReviewConfirmDateForm";
import {UserTypes} from "root/DataFunctions/Constants";
import he from 'he';
export default class ChildProgressReviewTabbedForm extends TabbedBasePage
{
	constructor(props) 
	{
		super(props);

		let loadingState = this.props.mode == 'create' && ( this.props.child_id == null || this.props.child_id == 0 ) ? false : true ;
		let currentChild = {} ;
		let initialisationState = 'view';

		if ( this.props.mode == 'create')
		{
			initialisationState = this.props.child_id != null && this.props.child_id != 0 ? 'confirm' : 'select' ;
		}

		if ( this.state == null )
		{
			this.state = {
			mode: this.props.mode,
			child: currentChild,
			initialisation: initialisationState,
			loading: loadingState, 
			review_date: null, 
			review_data: {}, 
			review_id: this.props.review_id,
			achievementType_data: {},
			user_id : this.props.user_id,
			child_id: this.props.child_id,
			activePage: 'attendance' ,
			displayErrors: false ,
			tabItems: this.getDefaultMenuItems()

			} ;			
		}
		else
		{
			this.state.mode = this.props.mode;
			this.state.child = currentChild;
			this.state.initialisation = initialisationState;
			this.state.loading  = loadingState ;
			this.state.review_date  = null ;
			this.state.review_id  = this.props.review_id ;
			this.state.review_data = {} ;
			this.state.achievementType_data = {} ;
			this.state.user_id = this.props.user_id;
			this.state.child_id = this.props.child_id;
			this.state.activePage = this.props.activePage;
			this.state.displayErrors= false;

			this.state.tabItems = this.getDefaultMenuItems() ;
		}

		this.lastFormAction = this.lastFormAction.bind(this) ;
		this.getReviewData = this.getReviewData.bind(this) ;
        this.returnToPreviousPage = this.returnToPreviousPage.bind(this) ;
	}

	UNSAFE_componentWillMount()
	{
		if ( this.state.mode == 'create')
		{
			if ( this.state.child_id != null && this.state.child_id != 0 )
			{
				this.getChildData( this.state.child_id) ;
			}
		}
		else
		{
			if ( this.state.mode == 'edit' || this.state.mode == 'view')
			{
				if ( this.state.review_id != null )
				{
					this.getReviewData ( this.state.review_id ) ;
				}
			}
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps)
	{
		if ( nextProps.value != this.props.value )
		{
			var isValid = this.isValueValid(nextProps.value) ;
		
			// Set our initial validity state
			this.setState ( { val: nextProps.value, valid: isValid }) ;
		}
	}

	processExistingReviewData ( data )
	{
		var progressReview = {} ;

		var attendance = {} ;
		var punctuality = {} ;

		// If we have an attendance ID then pass it on.
		if ( data.attendance_data.child_attendance_id != null )
		{
			attendance.child_attendance_id = data.attendance_data.child_attendance_id;
			attendance.year_start = data.attendance_data.year_start ;
			attendance.description = data.attendance_data.description ;
			attendance.dmy_date_from = data.attendance_data.dmy_date_from ;
			attendance.dmy_date_to = data.attendance_data.dmy_date_to ;
		}

		attendance.attended_days = data.attendance_data.attendance.attended_days ;
		attendance.out_of_days = data.attendance_data.attendance.out_of_days ;
		attendance.reason = data.attendance_data.attendance.reason ;
		attendance.action = data.attendance_data.attendance.action ;
		attendance.pcent = data.attendance_data.attendance.pcent ;
		attendance.authorised_absences = data.attendance_data.attendance.authorised_absences ;
		attendance.unauthorised_absences = data.attendance_data.attendance.unauthorised_absences ;

		punctuality.days = data.attendance_data.punctuality.days ;
		punctuality.out_of_days = data.attendance_data.punctuality.out_of_days ;
		punctuality.reason = data.attendance_data.punctuality.reason ;
		punctuality.action = data.attendance_data.punctuality.action ;
		punctuality.pcent = data.attendance_data.punctuality.pcent ;

		progressReview.attendance = attendance;
		progressReview.punctuality = punctuality;
		progressReview.feedback = data.feedback.feedback ;
		progressReview.progress_review_id = data.review_id;
		progressReview.progress_review_version = data.progress_review_version;
		progressReview.child_id = data.child_id ;
		progressReview.review_status = data.review_status ;
        progressReview.year_id = data.year_id ;
        progressReview.ppplus_flag = +(data.ppplus_flag) ;

        progressReview.ppplus = data.ppplus ;

        var displayText = data.feedback.feedback ;
        var htmlText = data.feedback.html ;

        let html = null ;

        if ( htmlText == null )
        {
            if ( displayText != null )
            {
                htmlText = displayText ;

                htmlText = htmlText.replace(/\r/g, "<br>");
                htmlText = htmlText.replace(/\n/g, "<br>");

                html = htmlText ;

                displayText = displayText.replace(/\\r/g, "\r");
                displayText = displayText.replace(/\\n/g, "\n");
            }
        }
        else
        {
            //displayText = displayText.replace(/\\r/g, "\r");
            //displayText = displayText.replace(/\\n/g, "\n");
            html = he.decode (htmlText) ;
        }

        progressReview.feedback = displayText ;
        progressReview.html = html ;

		progressReview.data = data.data ;

		if ( this.props.teacher_feedback == true )
		{
			if ( data.review_status == 1 )
			{
				this.setState ({ initialisation: 'view', loading:false, review_data: progressReview } );		
			}
			else
			{
				this.setState ({ initialisation: 'closed', loading:false, review_data: progressReview } );		
			}
		}
		else
		{
			this.setState ({ initialisation: 'view', loading:false, review_data: progressReview } );		
		}
	}
	
	// This function creates the review record structure from the child's template and returns the data
	// created ready to e displayed on the forms
	getReviewData ( review_id) 
	{
		const self = this ;

    	$.ajax({
    		  type: 'GET',
    		  url: Globals.APIFolder + '/reviews/'+review_id  ,
    		  success:(data)=>{

				  if ( checkError ( data))
				  {
				  	  if ( data.data.ppplus == null || +(data.data.ppplus_flag) !== 1 )
					  {
					  	self.setState ( {tabItems : self.menuItemsWithNoPPPlus()}) ;
					  }

					  self.processExistingReviewData ( data.data ) ;
				  }
    		  },
    		  error:(jqXHR, textStatus, error)=>{

					const url = atob(self.props.return_url) ;

					bootbox.alert({ 
					  size: "large",
					  title: "The operation failed",
					  message: error.stack + '\n' + jqXHR.responseText + '<br><br>' + getErrorObject().stack, 
					  callback: function()
					  { 
						  location.assign(url);
					  }
					})	    		  	
  		  }
    		});

	}
	

	// This function creates the review record structure from the child's template and returns the data
	// created ready to e displayed on the forms
	createReviewRecords ( child_id, reviewdata)
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
    	$.ajax({
    		  type: 'POST',
    		  url: root + '/children/' + child_id + '/review'  ,
    		  data: reviewdata,
    		  beforeSend:function(){
    		    // this is where we append a loading image
    		  },
    		  success:(data)=>{
  				if ( checkError(data))
				{
					var status = data.status ;
					var teacher_result = data.data.teacher_notification_status ;

					if ( status.result == 'success')
					{
						if ( teacher_result != null )
						{
							if ( teacher_result.status.result == 'success')
							{
								var emailMessage = "Email has been sent to the designated teacher" ;
							}
							else
							{
								var emailMessage = "Although the Progress Review has been created, we were unable to send a notification to the designated teacher. You must now contact the designated teacher to complete the pupil's assessment for this review" ;
								emailMessage += '<br><br>Further Details:<br><p>' + teacher_result.status.error + '</p>' ; 
								emailMessage += '<p>' + teacher_result.status.errorDetail + '</p>' ; 
							}
						}
						
						var returnurl = atob(this.props.return_url) ;

						bootbox.alert({ 
						  size: "large",
						  title: "The Review has been created",
						  message: "Operation Successful<br><br>"+emailMessage, 
						  callback: function()
						  { 
							  location.assign(returnurl);
						  }
						});
					}
				}
    			    
    			    //this.processReviewData ( child_id, reviewDate, data.status.insertId, data.data ) ;
  				
    		  },
    		  error:(jqXHR, textStatus, error)=>{

					var url = atob(this.props.return_url) ;

					bootbox.alert({ 
					  size: "large",
					  title: "The operation failed",
					  message: error.stack + '\n' + jqXHR.responseText + '<br><br>' + getErrorObject().stack, 
					  callback: function()
					  { 
						  location.assign(url);
					  }
					})	    		  	
  		  }
    		});

	}
	
		// This function creates the review record structure from the child's template and returns the data
	// created ready to e displayed on the forms
	updateReviewRecords ( reviewData) 
	{
		var data = { review_data: reviewData } ;
		
		var returnurl = atob(this.props.return_url) ;

    	$.ajax({
  		  type: 'PUT',
  		  url: Globals.APIFolder + '/children/' + reviewData.child_id + '/review',
  		  data: data,
  		  success:(data)=>{
			this.setState (
			{
				mode: 'view'
			});

			var returnurl = atob(this.props.return_url) ;

			bootbox.alert({
			  size: "large",
			  title: "Operation completed",
			  message: "The review has been saved. Click OK to return.",
			  callback: function()
			  {
				  location.assign(returnurl);
			  }
			})
  		  },
  		  error:function(jqXHR, textStatus, error)
		  {
			  handleAjaxError(jqXHR, textStatus, error, returnurl ) ;
  		  }
  		});
	}

	getChildData( child_id )
	{
    	$.ajax({
    		  type: 'GET',
    		  url: Globals.APIFolder + '/children/' + child_id  ,
    		  success:(data)=>
			  {
  				this.setState({ loading: false, child: data.data[0], initialisation: 'confirm' });
    		  },
    		  error:(jqXHR, textStatus, error)=>
			  {
			  	handleAjaxError(jqXHR, textStatus, error ) ;
			  }
    		});
	}

	formElement ()
	{
		var string = "<div>" ;

		string+= '<h2>Save Review Feedback</h2>' ;

		string+= '<p>You are about to save your feedback for this pupil.</p>' ;

		string+= '<p>You can either save this review to add more information later, or you can save and submit it back to the ESW, which will close your work item and remove it from your inbox.</p>' ;

		string+= '<p>Do you want to close the review and submit the final version?</p>' ;

		string += "</div>" ;

		return string ;
	}

	teacherQuestion( )
	{
		const self = this ;
		const form = this.formElement () ;

		const modal = bootbox.dialog({
			message: form,
			title: "",
			buttons: [
				{
					label: "Yes, close the review and send it to the ESW",
					className: "btn btn-primary pull-left",
					callback: function()
					{
						self.doLastFormAction( true ) ;
					}
				},
				{
					label: "No, just save it for now",
					className: "btn btn-default pull-right",
					callback: function()
					{
						self.doLastFormAction( false) ;
					}
				}
			],
			show: false,
			onEscape: function()
			{
				modal.modal("hide");
			}
		});

		modal.modal("show");
	}

	isTeacher()
	{
		return +(this.props.user_type) === 5 ;
	}

	userIsESLAC = () =>
	{
		return [ UserTypes.TEAM_LEAD, UserTypes.PERFORMANCE_AND_DEVELOPMENT, UserTypes.VIRTUAL_SCHOOL_HEAD, UserTypes.LEAD_CAREERS_ADVISOR, UserTypes.ESW ].includes(+(this.props.user_type)) ;
	}

	doLastFormSave()
	{
		// 02.05.2024 - allow ESWs to close the review also
		if ( this.isTeacher() || this.userIsESLAC() )
        {
			this.teacherQuestion();
        }
        else
        {
			this.doLastFormAction( false ) ;
        }
    }

	lastFormAction()
	{
		if ( this.areAllFormsValid())
		{
			this.doLastFormSave() ;
		}
		else
		{
			let message = "You have invalid data on this form. Do you want to correct it or discard the changes and return" ;

            var me  = this ;
            bootbox.confirm({
                message: message,
                buttons: {
                    confirm: {
                        label: 'Complete the form',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'No, lose my changes',
                        className: 'btn-default'
                    }
                },
                callback: function (result)
                {
                	if ( result == true )
					{

					}
					else
					{
						me.returnToPreviousPage() ;
					}
                }
            });
		}
	}

	areAllFormsValid()
	{
		let valid = true ;

        if ( this.refs.attendance != null )
        {
            if ( !this.refs.attendance.formIsValid())
			{
				valid = false ;
			}
        }

        if ( this.refs.achievement != null )
        {
            if ( !this.refs.achievement.formIsValid())
            {
                valid = false ;
            }
        }

        if ( this.refs.feedback != null )
        {
            if ( !this.refs.feedback.formIsValid())
            {
                valid = false ;
            }
        }

		if ( this.refs.ppplus != null )
		{
			if ( !this.refs.ppplus.formIsValid())
			{
				valid = false ;
			}
		}

        return valid ;
    }

	doLastFormAction( shouldClose )
	{
		var ok = true ;

		if ( this.refs.attendance != null )
		{
			if ( !this.refs.attendance.formIsValid())
			{
				ok = false ;
				this.setErrorTab ( 'attendance') ;
			}
			else
			{
				this.refs.attendance.autoSave() ;
			}	
		}

		if ( ok && this.refs.achievement != null )
		{
			if ( ok && !this.refs.achievement.formIsValid())
			{	
				ok = false;
				this.setErrorTab ( 'achievement') ;
			}
			else
			{
				this.refs.achievement.autoSave() ;
			}
		}

		if ( ok && this.refs.feedback != null )
		{
			if ( ok && !this.refs.feedback.formIsValid())
			{	
				this.setErrorTab ( 'feedback') ;
			}
			else
			{
				this.refs.feedback.autoSave() ;
			}
		}

		if ( ok && this.refs.ppplus != null )
		{
			if ( ok && !this.refs.ppplus.formIsValid())
			{
				this.setErrorTab ( 'ppplus') ;
			}
			else
			{
				this.refs.ppplus.autoSave() ;
			}
		}

		if ( shouldClose ) 
		{
			let complete = true ;
			let errorTab = '' ;

			if ( this.refs.achievement != null  && !this.refs.achievement.formIsComplete() )
			{
				complete = false ;
				errorTab = 'achievement' ;
			}

			if ( this.refs.feedback != null  && !this.refs.feedback.formIsComplete() )
			{
				complete = false ;
				errorTab = 'feedback' ;
			}

			if ( complete )
			{
				const reviewData = {
					progress_review_id : this.state.review_data.progress_review_id,
					child_id : this.state.child_id,
					close_review : true
				} ;

				this.updateReviewRecords ( reviewData ) ;
			}
			else
			{
				bootbox.alert({
					size: "large",
					title: "Incomplete Review",
					message: "You must complete this progress review to submit.",
					callback: function()
					{
					}
				})

				ok = false;
				this.setErrorTab ( errorTab ) ;
			}
		}
		else
		{
            this.operationSuccess();
		}

	}

	returnToPreviousPage()
	{
        location.assign(atob(this.props.return_url));
	}

	operationSuccess ()
	{
		if ( this.props.teacher_feedback == true )
		{
			var url = 'feedback_complete.php';

			location.assign(url);
		}
		else
		{
			var url = atob(this.props.return_url) ;

			bootbox.alert({ 
			  size: "large",
			  title: "Operation completed",
			  message: "The Feedback Review has been saved.", 
			  callback: function()
			  { 
		          location.assign(url);
			  }
			})		
		}
	}


	onSave()
	{
		if ( !this.refs.attendance.formIsValid())
		{
			this.setErrorTab ( 'attendance') ;
		}
		else if ( !this.refs.achievement.formIsValid())
		{
			this.setErrorTab ( 'achievement') ;
		}
		else if ( !this.refs.feedback.formIsValid())
		{
			this.setErrorTab ( 'feedback') ;
		}
		else
		{
			let attendanceData = this.refs.attendance.getFormData() ;
			let academicProgressReviewData = this.refs.achievement.getFormData() ;
			let feedbackData = this.refs.feedback.getFormData() ;

			if ( attendanceData.attendance.days > attendanceData.attendance.out_of_days )
			{
				this.setErrorTab ( 'attendance') ;
			}

			let reviewData = {} ;

			reviewData.attendance_data = attendanceData ;			
			reviewData.academic_progress = academicProgressReviewData ;			
			reviewData.feedback = feedbackData ;
			reviewData.progress_review_id = this.state.review_data.progress_review_id ;
			reviewData.child_id = this.state.child_id ;

			this.updateReviewRecords ( reviewData ) ;
		}
	}

	removeAchievementFromStack ( achievement_id )
	{
		let newReview = this.state.review_data ;

		newReview.data.achievement.members = newReview.data.achievement.members.filter(function(element)
		{
			if ( element.achievement_id == achievement_id )
			{
				return false ;
			}
			else {
				return true ;
			}
        });

		this.setState ( { review_data: newReview }) ;
	}

    onDeleteSubject ( achievement_id )
	{
		this.removeAchievementFromStack( achievement_id ) ;
	}

	tabContent ( id )
	{
		switch ( id )
		{
			case 'attendance':

				if ( this.state.review_data.progress_review_version == 3 || this.state.review_data.progress_review_version == 4 )
				{
					return React.createElement(ChildProgressReviewAttendance2, {
						key: 1,
						mode: this.state.mode,
						child_id: this.state.child_id,
						review_data: this.state.review_data,
						ref: 'attendance',
						onSave: this.onSave.bind(this),
						onCancel: this.onCancel.bind(this),
						attendanceData: this.state.review_data.attendance,
						punctualityData: this.state.review_data.punctuality,
						prevButtonRequired: this.shouldPrevButtonShow( id ),
						nextButtonRequired: this.shouldNextButtonShow( id ),
						showButtons: false,
						navigationNotifier: this.onNavigate.bind(this),
						autoSave: true,
						setting: 'progressreview',
						onDirty: this.onDirty.bind( this, 'attendance' ),
						setDirty: this.setDirty.bind( this, 'attendance' ),
						displayErrors: this.state.displayErrors}, null);

				}
				else
				{
					return React.createElement(ChildProgressReviewAttendance, {
						key: 1,
						mode: this.state.mode,
						child_id: this.state.child_id,
						review_data: this.state.review_data,
						ref: 'attendance',
						onSave: this.onSave.bind(this),
						onCancel: this.onCancel.bind(this),
						attendanceData: this.state.review_data.attendance,
						punctualityData: this.state.review_data.punctuality,
						prevButtonRequired: this.shouldPrevButtonShow( id ),
						nextButtonRequired: this.shouldNextButtonShow( id ),
						showButtons: false,
						navigationNotifier: this.onNavigate.bind(this),
						autoSave: true,
						onDirty: this.onDirty.bind( this, 'attendance' ),
						setDirty: this.setDirty.bind( this, 'attendance' ),
						displayErrors: this.state.displayErrors}, null);
					break ;

				}

			case 'achievement':
				if ( this.state.review_data.progress_review_version == 3 || this.state.review_data.progress_review_version == 4 )
				{
					return React.createElement(ChildProgressReviewAchievement, {
						key: 3,
						ref: 'achievement',
						mode: this.state.mode,
						onSave: this.onSave.bind(this),
						onCancel: this.onCancel.bind(this),
						progressAchievedRequired: true,
						review_id: this.state.review_id,
						data_element: 'academic_progress',
						data_element_name: 'achievement',
						child_id: this.state.child_id,
						review_data: this.state.review_data,
						year_id: this.state.review_data.year_id,
						progress_review_version: this.state.review_data.progress_review_version,
						prevButtonRequired: this.shouldPrevButtonShow(id),
						nextButtonRequired: this.shouldNextButtonShow(id),
						showButtons: false,
						navigationNotifier: this.onNavigate.bind(this),
						onDeleteSubject: this.onDeleteSubject.bind(this),
						autoSave: true,
						onDirty: this.onDirty.bind(this, 'achievement'),
						setDirty: this.setDirty.bind(this, 'achievement'),
						displayErrors: this.state.displayErrors
					}, null);
				}
				else
				{
					return React.createElement(ChildProgressReviewAchievementLegacy, {
						key: 3,
						ref: 'achievement',
						mode: this.state.mode,
						onSave: this.onSave.bind(this),
						onCancel: this.onCancel.bind(this),
						progressAchievedRequired: true,
						review_id: this.state.review_id,
						data_element: 'academic_progress',
						data_element_name: 'achievement',
						child_id: this.state.child_id,
						review_data: this.state.review_data,
						//						data: this.state.review_data.data.achievement,
						year_id: this.state.review_data.year_id,
						progress_review_version: this.state.review_data.progress_review_version,
						prevButtonRequired: this.shouldPrevButtonShow(id),
						nextButtonRequired: this.shouldNextButtonShow(id),
						showButtons: false,
						navigationNotifier: this.onNavigate.bind(this),
						onDeleteSubject: this.onDeleteSubject.bind(this),
						autoSave: true,
						onDirty: this.onDirty.bind(this, 'achievement'),
						setDirty: this.setDirty.bind(this, 'achievement'),
						displayErrors: this.state.displayErrors
					}, null);
				}
				break ;
			case 'feedback':
				return React.createElement(ChildProgressReviewFeedback, {  
					key: 3,
					mode: this.state.mode,
					onSave: this.onSave.bind(this),
					onCancel: this.onCancel.bind(this),
					feedback: this.state.review_data.feedback,
                    html: this.state.review_data.html,
					prevButtonRequired: this.shouldPrevButtonShow( id ),
					child_id: this.state.child_id,
					review_data: this.state.review_data,
					nextButtonRequired: this.shouldNextButtonShow( id ), 
					saveButtonRequired: !this.shouldNextButtonShow( id ), 
					showButtons: false,
					navigationNotifier: this.onNavigate.bind(this),
                    onDirty: this.onDirty.bind( this, 'feedback' ),
                    setDirty: this.setDirty.bind( this, 'feedback' ),
					autoSave: true,
					ref: 'feedback' }, null);
				break ;

			case 'ppplus':
				return <ChildPupilPremiumPlus
					key={4}
					mode={this.state.mode}
					onSave={this.onSave.bind(this)}
					onCancel={this.onCancel.bind(this)}
					prevButtonRequired={this.shouldPrevButtonShow( id )}
					child_id={this.state.child_id}
					review_data={this.state.review_data}
					attendanceData={this.state.review_data.attendance}
					nextButtonRequired={this.shouldNextButtonShow( id )}
					saveButtonRequired={!this.shouldNextButtonShow( id )}
					showButtons={false}
					setting='progressreview'
					navigationNotifier={this.onNavigate.bind(this)}
					onDirty={this.onDirty.bind( this, 'ppplus' )}
					setDirty={this.setDirty.bind( this, 'ppplus' )}
					autoSave={true}
					isPPPlus={this.props.isPPPlus}
					ref='ppplus' />
			default:
				return React.createElement('h1', {  key: 1 }, 'Content for Page ' + id) ;			
				break ;

		}
	}

    getMenuItems()
    {
        return this.state.tabItems ;
    }

    getDefaultMenuItems()
	{
		const tabItems =
		{
			activePanel: 'attendance',
			items:
			[
				{id: 'attendance',  prev: null, next: 'achievement', title: 'Attendance', enabled: true, dirty: false},
				{id: 'achievement',  prev: 'attendance', next: 'feedback', title: 'Progress' , enabled: true, dirty: false},
				{id: 'feedback', prev: 'achievement', next: 'ppplus', title: 'Feedback', enabled: true, dirty: false},
				{id: 'ppplus', prev: 'feedback', next: null, title: 'Pupil Premium Plus', enabled: true, dirty: false},
			]
		} ;

		return tabItems;
	}

	menuItemsWithNoPPPlus()
	{
		const tabItems =
			{
				activePanel: 'attendance',
				items:
					[
						{id: 'attendance',  prev: null, next: 'achievement', title: 'Attendance', enabled: true, dirty: false},
						{id: 'achievement',  prev: 'attendance', next: 'feedback', title: 'Progress' , enabled: true, dirty: false},
						{id: 'feedback', prev: 'achievement', next: null, title: 'Feedback', enabled: true, dirty: false},
					]
			} ;

		return tabItems;
	}

	renderedComponent()
	{
    	return React.createElement ('div', {  key: 'ProgressNavTabs', className: 'input-group' }, this.tabbedHeaders('nav-tabs'));
	}
	
	onConfirmDate() 
	{
		const reviewdata = this.refs.ConfirmDateForm.getFormData()

		this.createReviewRecords ( this.state.child_id, reviewdata ) ;
	}

	onConfirmDateAfterSelect() 
	{
		const child_id = this.refs.ConfirmSelectChildForm.refs.InputSelectedChild.getValue() ;

		if ( child_id > 0 )
		{
			var reviewDate = this.refs.ConfirmSelectChildForm.refs.InputReviewDate.getValue() ;

			this.createReviewRecords ( child_id, reviewDate ) ;			
		}
		else
		{
			this.setState ({displayErrors : true }) ;
		}
	}
	
	onCancel() 
	{
		if ( this.props.onCancel != null )
		{
			this.props.onCancel() ;
		}
		else
		{
			var returnURL = atob(this.props.return_url) ;

			location.assign(returnURL);		
		}
	}
	
	renderDateScreen()
	{
		return React.createElement ( ChildProgressReviewConfirmDateForm, { 
			key: 'ConfirmDateForm',
			displayErrors: this.state.displayErrors,
			ref: 'ConfirmDateForm', 
			mode: 'create', 
			onCancel: this.onCancel.bind(this), 
			onSave: this.onConfirmDate.bind(this), 
			return_url: this.props.return_url,
			child: this.state.child }) ;
	}

	renderChooseChildScreen()
	{
		return React.createElement ( ChildProgressReviewSelectChildForm, { 
			key: 'SelectChildForm',
			displayErrors: this.state.displayErrors,
			ref: 'ConfirmSelectChildForm', 
			mode: 'create', 
			user_id: this.props.user_id,
			onCancel: this.onCancel.bind(this), 
			onSave: this.onConfirmDateAfterSelect.bind(this), 
			return_url: this.props.return_url,
			child: this.state.child }) ;
	}

	renderClosedScreen()
	{
		return React.createElement ( ChildProgressReviewClosedForm, { 
			key: 'ClosedForm',
			displayErrors: this.state.displayErrors,
			mode: 'view', 
			child: this.state.child }) ;
	}
	
    render() 
    {
    	if ( this.state.loading == true )
    	{
			return React.createElement(SpinnerDiv);
    	}
    	else
    	{
			switch ( this.state.initialisation)
			{
			case 'confirm':
				return this.renderDateScreen() ;
				break ;

			case 'closed':
				return this.renderClosedScreen() ;
				break ;

			case 'select':
				return this.renderChooseChildScreen() ;
				break ;

			default:
				return this.renderedComponent() ;    	
			}

    	}
    }
}


